import wixWindow from 'wix-window';

$w.onReady(function () {
	setTimeout(function(){
	let FormFactor = wixWindow.formFactor // "Mobile" /"Desktop"
	let language = wixWindow.multilingual.currentLanguage; // "en"
	if (FormFactor !== "Mobile")
	{
	if (language === "en")
	{
		$w('#statebox8').changeState("EN1")
		
	}
	else if (language === "he"){
		$w('#statebox8').changeState("HE1")
	}
	}
	else
	{
		$w('#statebox8').collapse();
		 if (language === "he"){
		$w('#BurgerMenu').show()
		$w('#mobileMenu1').hide();	
		 }
	}
 }, 500);

});

